import { RoomsInDealContainer } from '../../containers/advancedFilters/RoomsInDealContainer';
import { IFilter } from '../../types/advancedFilters';

export const roomsInDeal: IFilter = {
  component: RoomsInDealContainer,
};
